export const get_currency_conversions = `query get_currency_conversions($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_currency_conversions(paginator: $paginator, order: $order, filter: $filter){
        currency_conversions{
            transaction_code
            status
            account
            from_currency{
                currency
                name
                decimal
            }
            to_currency{
                currency
                name
                decimal
            }
            from_amount
            to_amount
            exchange_rate
            order_date
        }
        page
        page_count
    }
}`;
